import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
export const Required = _ref => {
  let {
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1785068162", [spacers.dp4]]])
  }, "*", /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1785068162",
    dynamic: [spacers.dp4]
  }, ["span.__jsx-style-dynamic-selector{padding-inline-start:".concat(spacers.dp4, ";}")]));
};
Required.propTypes = {
  dataTest: PropTypes.string.isRequired
};